















































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
import { Dialog } from "vant";
import axios from "axios";
import { Notify } from "vant";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    sidebar,
    ConversationIcon,
    WordsIcon,
    GrammarIcon,
    HeadphonSVG,
  },
})
export default class Sentences extends Vue {
  editedSentence: any = null;
  @Prop() Sentences!: any;
  @Prop() Chapter!: any;
  @Prop() CategoryId!: any;
  testChap: any = null;
  editSentence(sentence: any) {
    this.editedSentence = sentence;
  }

  @Emit("UpdateChapter")
  UpdateChapter() {
    return this.Chapter;
  }
  @Emit("SaveTranslation")
  SaveTranslation(sentence: any) {
    return sentence;
  }
  @Emit("DeleteTranslation")
  DeleteTranslation(sentenceId: any) {
    return sentenceId;
  }

  SaveChapter() {
    const data = { category_id: this.CategoryId, chapter: this.Chapter };
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/UpdateConversationChapter",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Chapter is not Updated" });
      });
    Notify({ type: "success", message: "Chapter Updated" });
  }
  ShowEditInput(sentence: any, DivId: any) {
    this.DivId = -1;
    this.DivId = DivId;
    this.MakeAllFalse();
    sentence.showNarrator = true;
  }
  MakeAllFalse() {
    for (let i = 0; i < this.Sentences.length; i++) {
      this.Sentences[i].showNarrator = false;
    }
  }

  ConvId: any;
  chap: any;
  TextChange = "12";
  DivId = -1;
  EditId = -1;
  hover: boolean = false;
  DeleteSentence(index: any) {
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        if (this.$route.name == "main.translations") {
          this.DeleteTranslation(this.Sentences[index].id);
          this.$delete(this.Sentences, index);
        } else this.$delete(this.Chapter.sentences, index);
      })
      .catch(() => {
        // on cancel
      });
  }
  EditedSentence: { SentenceIndex: number; Sentence: string; Edited: boolean }[];
  MouseHover(DivId: any) {
    this.DivId = DivId;
  }
  MouseLeave(DivId: any) {
    this.DivId = -1;
  }
  chapters = this.Conversation;
  EditSentence(id: any) {
    this.EditId = id;
  }
  get ConversationId() {
    this.ConvId = this.$route.params.ConversationId;
    return this.$route.params.ConversationId;
  }
  get ChapterId() {
    return this.$route.params.ChapterId;
  }
  get getSentences() {
    // add a column for inline edit
    const sentences = this.Sentences;
    return sentences.map((v: any) => ({ ...v, edit: false }));
  }
  // get Chapter() {
  //   return this.Conversation[0].chapters.filter((item) => {
  //     return item.id == this.ChapterId;
  //   });
  // }
  SaveSentence(index: any) {
    const indexw = index;
  }
  created() {
    const chapt = this.Chapter.sentences;
    console.log(chapt.map((v: any) => ({ ...v, edit: false })));
  }
  get Conversation() {
    return data.conversationCategories.filter((item) => {
      return item.id == this.ConversationId;
    });
  }
  getImgUrl(item: any) {
    return item.imageUrl;
  }
}
